import React from 'react';
import defaultLogo from '../../../images/sony-logo.png';

const TopBar: React.FC<any> = ({ sonyLogo, sonySecondLogo }) => {
  return (
    <section className="top-bar">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-12">
            <div className="d-flex justify-content-between">
              <p>
                <img alt="sony logo" src={sonyLogo || defaultLogo} />
              </p>
              {sonySecondLogo ? <div dangerouslySetInnerHTML={{__html:sonySecondLogo}}></div> : ""}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopBar;
